'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_components_MessageState(spinny, msg, msgTitle, severity) {
  this.LQ = false;
  this.Dh = null;
  this.Di = null;
  this.LP = null;
  this.LQ = spinny;
  this.Dh = msg;
  this.Di = msgTitle;
  this.LP = severity;
}
export { $c_Lmealorama_components_MessageState as $c_Lmealorama_components_MessageState };
$p = $c_Lmealorama_components_MessageState.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_components_MessageState;
/** @constructor */
function $h_Lmealorama_components_MessageState() {
}
export { $h_Lmealorama_components_MessageState as $h_Lmealorama_components_MessageState };
$h_Lmealorama_components_MessageState.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, (-1132849942));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, (this.LQ ? 1231 : 1237));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.Dh));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.Di));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.LP));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().ax(acc, 4);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_components_MessageState)) {
    if ((this.LQ === x$0.LQ)) {
      var x = this.Dh;
      var x$2 = x$0.Dh;
      var $x_2 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.Di;
      var x$4 = x$0.Di;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_BoxesRunTime$().s(this.LP, x$0.LP);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 4;
});
$p.r = (function() {
  return "MessageState";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.LQ;
      break;
    }
    case 1: {
      return this.Dh;
      break;
    }
    case 2: {
      return this.Di;
      break;
    }
    case 3: {
      return this.LP;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lmealorama_components_MessageState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kg)));
}
export { $isArrayOf_Lmealorama_components_MessageState as $isArrayOf_Lmealorama_components_MessageState };
var $d_Lmealorama_components_MessageState = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_components_MessageState, "mealorama.components.MessageState", ({
  kg: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_components_MessageState as $d_Lmealorama_components_MessageState };
//# sourceMappingURL=mealorama.components.-Message-State.js.map
